import React from 'react';
import Workbook from 'react-excel-workbook';

export default ({ workbookData, workbookColumns }) => {
    return (
        <Workbook
            filename="EMR-Report.xlsx"
            element={
                <button className="btn btn--download" title="Download">
                    <svg className="icon icon-download">
                        <use xlinkHref="#icon-download" />
                    </svg>
                </button>
            }
        >
            <Workbook.Sheet data={workbookData} name="EMR Report">
                {workbookColumns.map(item => {
                    return (
                        <Workbook.Column
                            key={item.property}
                            label={item.header.label}
                            value={item.property}
                        />
                    );
                })}
            </Workbook.Sheet>
        </Workbook>
    );
};



// WEBPACK FOOTER //
// ./src/components/reporting/workbook-data.js